(function () {

    var services = {
        gtm: {
            init: function (gtmID) {
                (function (w, d, s, l, i) {
                    w[l] = w[l] || [];
                    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

                    var f = d.getElementsByTagName(s)[0],
                        j = d.createElement(s),
                        dl = l != 'dataLayer' ? '&l=' + l : '';

                    j.async = true;
                    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                    f.parentNode.insertBefore(j, f);
                })(window, document, 'script', 'dataLayer', gtmID);
            }
        },

        activateAnchorOnScroll: {
            init: function (navigationSelector, navigationActiveCssClass) {
                $(navigationSelector).activateAnchorOnScroll({ activeCssClass: navigationActiveCssClass });
            }
        },

        checkjs: {
            init: function () {
                document.documentElement.className = 'js';
            }
        },

        lazyLoad: {
            init: function (lazySelector) {

                $(lazySelector).Lazy({
                    onError: function (element) {
                        element.addClass('lazy--error');
                    }
                });
            }
        },

        smoothScroll: {
            init: function (smoothScrollSelector) {
                new SmoothScroll(smoothScrollSelector);
            }
        },

        menuToggler: {
            init: function (options) {
                var thismenu = this;
                $(options.togglerSelector + ',' + options.navigationSelector).click(function () {
                    if ($(options.togglerSelector).is(':visible')) {
                        thismenu.toggle(options);
                    }
                });


                // if media is desktop or menu is open then hidden is false else it's true
                (function () {
                    var mediaTriggerListener = function (q) {
                        thismenu.setAsHidden(options, !q.matches && !thismenu.isMenuOpen);
                    }
                    var matchMedia = window.matchMedia(options.mediaTrigger);
                    // check later
                    matchMedia.addListener(mediaTriggerListener);
                    // check now
                    mediaTriggerListener(matchMedia);
                })();


                // create cycling tab focus on keypress when menu is open
                (function () {
                    $(options.navigationLinkSelector).last().on('keydown', function (e) {
                        if (thismenu.isMenuOpen) {
                            if ((e.which === 9 && !e.shiftKey)) {
                                e.preventDefault();
                                $(options.togglerSelector).focus();
                            }
                        }
                    });

                    $(options.togglerSelector).on('keydown', function (e) {
                        if (thismenu.isMenuOpen) {
                            if ((e.which === 9 && e.shiftKey)) {
                                e.preventDefault();
                                $(options.navigationLinkSelector).last().focus();
                            }
                        }
                    });
                })();

            },
            isMenuOpen: false,
            toggle: function (options) {
                var body = $('body'); 
                var thismenu = this;

                $(options.navigationSelector).toggleClass(options.toggleCssClass);
                body.toggleClass(options.toggleAppCssClass);
                $(options.togglerIconSelector).toggleClass(options.toggleIconCssClass);
                thismenu.isMenuOpen = body.hasClass(options.toggleAppCssClass);

                // WAI-aria bits
                (function () {
                    $(options.togglerSelector).attr('aria-expanded', thismenu.isMenuOpen.toString());

                    setTimeout(function () {
                        thismenu.setAsHidden(options, !thismenu.isMenuOpen);
                    }, thismenu.isMenuOpen ? 0 : 400);
                })();

                if (options.enableGTM && options.enableTracking) {
                    window.dataLayer.push({
                        'event': 'GAMenu',
                        'eventCategory': 'menu',
                        'eventAction': body.hasClass(options.toggleAppCssClass) ? 'open' : 'close'
                    });
                }
            },
            setAsHidden: function (options, hidden) {
                $(options.navigationSelector).toggleClass('not-visible', hidden);
            }
        },

        printServices: {
            init: function (lazySelector) {
                $(window).on('beforeprint', function () {

                    $(lazySelector).lazy({
                        bind: "event",
                        delay: 0
                    });

                });
            }
        },

        progressBar: {
            init: function (cssClass) {
                progressBarOnScroll.init({ cssClass: cssClass });
            }
        },

        videoTracking: {
            init: function () {
                function pushGAEvent(videoElem, action) {
                    window.dataLayer.push({
                        'event': 'GAVideo',
                        'eventCategory': 'video',
                        'eventAction': action,
                        'eventLabel': videoElem.currentSrc || 'source empty',
                        'eventValue': videoElem.currentTime
                    });
                }

                $('video')
                    .on('play', function () { if (!this.seeking) { pushGAEvent(this, 'play'); } })
                    .on('pause', function () { if (!this.ended && !this.seeking) { pushGAEvent(this, 'pause'); } })
                    .on('ended', function () { if (!this.seeking) { pushGAEvent(this, 'ended'); } });
            }
        },

        webfont: {
            init: function (fontFamilies) {
                WebFont.load({
                    google: {
                        families: fontFamilies
                    }
                });
            }
        }
    }

    var appSettings = {
        enableSmoothScroll: true,
        enableProgressBar: true,
        enableLazyLoad: true,
        enableActivateAnchorOnScroll: true,
        enableMenuToggler: true,
        enableVideoTracking: true,
        enablePrintServices: true,
        enableWebFont: true,
        enableGTM: true
    }

    var app = {
        init: function (options, services) {
            var beforeDOMready = function () {
                services.checkjs.init();

                if (options.enableGTM) {
                    services.gtm.init('GTM-WQST7QP');
                }

                if (options.enableWebFont) {
                    services.webfont.init(['Lato']);
                }
            }

            var afterDOMready = function () {
                // After dom ready
                $(function () {

                    if (options.enableSmoothScroll) {
                        services.smoothScroll.init('.navigation__link');
                    }

                    if (options.enableProgressBar) {
                        services.progressBar.init('progress-bar');
                    }

                    if (options.enableLazyLoad) {
                        services.lazyLoad.init('.lazy');
                    }

                    if (options.enableActivateAnchorOnScroll) {
                        services.activateAnchorOnScroll.init('.navigation__link', 'navigation__link--active');
                    }

                    if (options.enableMenuToggler) {
                        services.menuToggler.init({
                            togglerSelector: '.menu-toggler',
                            navigationSelector: '.navigation',
                            navigationLinkSelector: '.navigation__link',
                            toggleCssClass: 'navigation--asmenu',
                            toggleAppCssClass: 'app--menu-open',
                            togglerIconSelector: '.menu-toggler__icon',
                            toggleIconCssClass: 'menu-toggler__icon--menu-open',
                            mediaTrigger: "(min-width: 820px)",
                            enableTracking: true
                        });
                    }

                    if (options.enableVideoTracking) {
                        services.videoTracking.init();
                    }

                    if (options.enablePrintServices) {
                        services.printServices.init('.lazy');
                    }
                });
            }

            beforeDOMready();
            afterDOMready();
        }
    }

    app.init(appSettings, services);

})();

